import { useState, useEffect } from "react";
import "./report.scss";
import Select from "react-select";
import { Range, getTrackBackground } from "react-range";
import DatePicker from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { CompletedOrdersTab, WaitingOrdersTab } from "./Orders.tsx";

function Report() {
  function RangeInput() {
    const [values, setValues] = useState([20, 40]);
    const STEP = 0.1;
    const MIN = 0;
    const MAX = 100;
    const rtl = true;
    return (
      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        rtl={rtl}
        onChange={(values) => setValues(values)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "36px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values,
                  colors: ["#ccc", "#548BF4", "#ccc"],
                  min: MIN,
                  max: MAX,
                  rtl,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ index, props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "42px",
              width: "42px",
              borderRadius: "4px",
              backgroundColor: "#FFF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 2px 6px #AAA",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-28px",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "14px",
                fontFamily: "Arial,Helvetica Neue,Helvetica,sans-serif",
                padding: "4px",
                borderRadius: "4px",
                backgroundColor: "#548BF4",
              }}
            >
              {values[index].toFixed(1)}
            </div>
            <div
              style={{
                height: "16px",
                width: "5px",
                backgroundColor: isDragged ? "#548BF4" : "#CCC",
              }}
            />
          </div>
        )}
      />
    );
  }
  const [values1, setValues1] = useState([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days"),
  ]);
  const { orders, setOrders } = useState([]);

  return (
    <div className="report " style={{ paddingRight: "65px" }}>
      <div className="row w-100">
        <div className="border  col-md-5 col-sm-12 report-div p-1">
          <h4>مجموع سفارشات</h4>
          <h4>500,000</h4>
        </div>
        <div className="border report-div p-1 col-md-5 col-sm-12 ">
          <h4>تعداد سفارشات</h4>
          <h4>500,000</h4>
        </div>
        <div className="border report-div p-1 col-md-5 col-sm-12 ">
          <h4>کمیسیون</h4>
          <h4>500,000</h4>
        </div>
        <div className="border report-div p-1 col-md-5 col-sm-12 ">
          <h4>تعداد آیتمهای سفارشات</h4>
          <h4>500,000</h4>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary px-5 mt-2"
        data-bs-toggle="modal"
        data-bs-target="#filter"
      >
        فیلتر
      </button>

      <div
        class="modal fade"
        id="filter"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                فیلتر گزارشات
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="">
                <lable>مشتری یا مشتریان :</lable>

                <Select
                  className="basic-single my-2"
                  classNamePrefix="select"
                  isRtl={true}
                  isSearchable={true}
                  // defaultValue={}
                  // value={toUserFakeValue1}
                  // options={userList.map((value) => {
                  //   return {
                  //     value: value.walletId,
                  //     label: value.fullname + " - " + value.mobile,
                  //   };
                  // })}
                  // ref={addModalFromWallet}
                  // onChange={(obj) => {
                  //   setToUserFakeValue1(obj);
                  //   setAddModalValues({
                  //     ...addModalValues,
                  //     fromWalletId: obj.value,
                  //   });
                  // }}
                />
              </div>
              <div className="mt-4">
                <lable>محصول:</lable>

                <Select
                  className="basic-single my-2"
                  classNamePrefix="select"
                  isRtl={true}
                  isSearchable={true}
                  // defaultValue={}
                  // value={toUserFakeValue1}
                  // options={userList.map((value) => {
                  //   return {
                  //     value: value.walletId,
                  //     label: value.fullname + " - " + value.mobile,
                  //   };
                  // })}
                  // ref={addModalFromWallet}
                  // onChange={(obj) => {
                  //   setToUserFakeValue1(obj);
                  //   setAddModalValues({
                  //     ...addModalValues,
                  //     fromWalletId: obj.value,
                  //   });
                  // }}
                />
              </div>
              <div className="mt-4">
                <label>مبلغ :</label>
                <RangeInput />
              </div>
              <div className="mt-4">
                <label>کمیسیون :</label>
                <RangeInput />
              </div>
              <div className="mt-4">
                <label>تاریخ : </label>
                <DatePicker
                  inputClass="form-control"
                  value={values1}
                  onChange={setValues1}
                  range
                  calendar={persian}
                  locale={persian_fa}
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                لغو
              </button>
              <button type="button" class="btn btn-primary">
                فیلتر
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        {/* <WaitingOrdersTab
          orders={orders.filter((value) => value.lats_order_status != 4)}
        />
        <CompletedOrdersTab
          orders={orders.filter((value) => value.lats_order_status == 4)}
        /> */}
      </div>
    </div>
  );
}

export default Report;
